import loadProductModule from './modules/Product.module';
import loadAuthenticationModule from './modules/Authentication.module';
import loadSessionModule from './modules/Session.module';
const loadProductReviewModule = (initialData) => ({
    hasRouter: false,
    modules: [loadProductModule(initialData), loadSessionModule(), loadAuthenticationModule()],
});
export default loadProductReviewModule;
